import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-responsive-modal";
import { closeQuickView } from "../../../redux/action/quickViewAction";
import styled from "styled-components";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Pagination]);

const TestModalWrapper = styled.div`
  width: 100%;
  /* height: 80vh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  & h4 {
  }
  & li {
    margin-bottom: 1rem;
    :last-of-type {
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: 991px) {
    & h4 {
      font-size: 24px;
    }
    & h6 {
      font-size: 18px;
    }
  }
  @media screen and (max-width: 575px) {
    & h4 {
      font-size: 20px;
    }
    & h6 {
      font-size: 14px;
    }
  }
`;

const SliderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  @media screen and (max-width: 575px) {
    width: 100%;
  }
`;

const SliderImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    margin: auto 0;
  }
`;

const PortFolioQuickView = ({ quickView, closeQuickView }) => {
  return (
    <>
      <Modal open={quickView ? true : false} onClose={closeQuickView}>
        {quickView && (
          <div className="quick-view overflow-hidden">
            <TestModalWrapper>
              <SliderWrapper>
                <SliderImgWrapper>
                  <img src={quickView.img_url} alt="" />
                </SliderImgWrapper>
              </SliderWrapper>
              <div className="w-50">
                <h4 className="mb-20">상품 정보</h4>
                <ul className="flex">
                  <li>
                    <h6>품명 : {quickView.name}</h6>
                  </li>
                  <li>
                    <h6>재질 : {quickView.texture}</h6>
                  </li>
                  {quickView.print && (
                    <li>
                      <h6>인쇄 : {quickView.print}</h6>
                    </li>
                  )}
                  {quickView.size && (
                    <li>
                      <h6>사이즈 : {quickView.size}</h6>
                    </li>
                  )}
                </ul>
              </div>
              <a
                className="btn mt-20 py-2 px-5"
                href="/customizing/customizing-products/"
              >
                견적 요청
              </a>
            </TestModalWrapper>
          </div>
        )}
        {/* <div
          className="slider-arrow hero-slider-1-arrow"
          style={{ top: "40%" }}
        >
          <span className="slider-btn slider-prev slick-arrow custom_prev_i1">
            <i className="fi-rs-angle-left"></i>
          </span>
          <span className="slider-btn slider-next slick-arrow custom_next_i1">
            <i className="fi-rs-angle-right"></i>
          </span>
        </div> */}
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  quickView: state.quickView,
});

export default connect(mapStateToProps, { closeQuickView })(PortFolioQuickView);
